import React, { useEffect } from "react";
import { useNavigate, useParams, useSearchParams } from "react-router-dom";
import LoadingScreen from "../components/loading/LoadingScreen";
import { buildDisplayURL } from "./Setup";
import { initialState } from "../stores/ConfigStore";


const LegacyPage: React.FC = () => {
    let navigate = useNavigate();
    const { tenantId, deviceName = "", controller } = useParams();
    const [searchParams] = useSearchParams();

    useEffect(() => {
        const placeholderUrlValue = searchParams.get('advertisementUrl');
        const deviceNameValue = deviceName.substring(4);

        let { setup, design } = initialState
        if (tenantId) {
            setup.tenantId = tenantId
        }
        if (deviceName) {
            setup.deviceName = deviceNameValue
        }
        if (placeholderUrlValue &&  !placeholderUrlValue.includes('display.casablanca.at/Placeholder')) {
            setup.placeholderUrl = placeholderUrlValue
        }
        const url = buildDisplayURL({ setup, design });
        navigate(url);
    }, []);

    return (
        <div style={{ position: 'relative' }}>
            <LoadingScreen isVisible={true} />
        </div>
    );
};
export default LegacyPage;